module.exports = __webpack_public_path__ + "img/savePictureWhite.3773089f.svg";